import { TaskCategoryAddonResource } from 'dy-frontend-http-repository/lib/modules/TaskCategoryAddon/resources';
import { resetTaskCategoryAddons } from './events';
import domain from './domain';

// Task addons
export const $taskCategoryAddons = domain
    .createStore<TaskCategoryAddonResource[] | null>(null)
    .reset(resetTaskCategoryAddons);
